/**
 * Core: EventBus
 * ------------------------------------------------------------------------------
 * - Usable EventBus, either global or per-component.
 *
 * @namespace EventBus
 */
/**
 * Create a new EventBus instance.
 */
export default () => {
  const eventBus = {}

  /**
   * Remove a given listener.
   * @param {String} event - Name of the event in which to delete.
   * @returns {Void}
   */
  function remove(event) {
    return delete eventBus[event]
  }

  /**
   * Dispatch a given event.
   * @param {String} event - Name of the event in which to subscribe to.
   * @param {*} payload - Payload to send to listeners.
   * @returns {Function|Array}
   */
  function dispatch(event, payload) {
    if (!eventBus[event]) {
      return false
    }

    /**
     * Execute.
     */
    return [...eventBus[event]].forEach((callback) => callback(payload))
  }

  /**
   * Subscribe to a given event.
   * @param {Array|String} events - Name of the event in which to dispatch
   * @param {Function} callback - Callback function to execute.
   * @returns {Array}
   */
  function on(events, callback) {
    return [events].flat().forEach((event) => {
      eventBus[event] = (eventBus[event] || []).concat(callback)
    })
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    dispatch,
    on,
    remove,
  })
}